export function isFileSegment(
  item?: ProposalSegment | Partial<ProposalSegment & Record<'id', string>>,
): item is FileSegment {
  return item?.type === 'file';
}
